import * as actionsType from '@/constants/deviceInfoActionsType';
import * as APPDATA from '@/constants/pcConstAppData';

export const initialState = {
  deviceSerialNumber: undefined,
  firmwareName: 'No Value',
  firmwareVersion: undefined,
  softwareName: undefined,
  softwareVersion: undefined,
  buildDate: undefined,
  hostName: undefined,
  ipAddress: undefined,
  macAddress: undefined,

  licenseStatus: 'Not activated',
  licenseType: '-',
  licenseModifiedDate: '-',
  licenseExpiredDate: '-',
  clientID: '-',
  licenseActivationMode: APPDATA.LICENSE_ACTIVATION_MODE.ONLINE,
  isTrialAvailable: true,
  licenseError: undefined,
  licenseURL: undefined,
  licenseID: undefined,
  licenseDayLeft: 0,
  licenseDayLeftCheckDate: undefined,
  licenseDayLeftAlertAvailable: false,
  deviceNameUserSet: null,
  deviceProperties: {
    deviceName: 'uPULSE',
    originDeviceName: 'uPULSE',
    organization: 'Formulatrix',
    originOrganitation: 'Formulatrix',
    deviceDateTime: new Date(),
    originDeviceDateTime: new Date(),
    localTimeZone: '',
  },
  hardwareProperties: {
    BuildDate: null,
    DaugtherBoard: null,
    DeviceID: null,
    DigitalSensorBoard: null,
    VolumeSensorBoard: null,
  },
  autoTimezone: false,
  autoDateTime: false,
  originAutoTimezone: false,
  originAutoDateTime: false,
  timezoneFromServer: {
    Date: null,
    Day: null,
    Hour: null,
    Minute: null,
    Month: null,
    Seconds: null,
    Time: null,
    Year: null,
    Zone: null,
  },
  trialDuration: 0,
};

export function deviceInfoStore(state = initialState, action = {}) {
  switch (action.type) {
    // -------------------------------------------------
    // Defice info
    // --------------------------------------------------
    case actionsType.UPDATE_DEVICE_INFO:
      return {
        ...state,
        deviceSerialNumber:
          action.value.deviceSerialNumber === undefined ? state.deviceSerialNumber : action.value.deviceSerialNumber,
        firmwareName: action.value.firmwareName === undefined ? state.firmwareName : action.value.firmwareName,
        firmwareVersion:
          action.value.firmwareVersion === undefined ? state.firmwareVersion : action.value.firmwareVersion,
        softwareName: action.value.softwareName === undefined ? state.softwareName : action.value.softwareName,
        softwareVersion:
          action.value.softwareVersion === undefined ? state.softwareVersion : action.value.softwareVersion,
        buildDate: action.value.buildDate === undefined ? state.buildDate : action.value.buildDate,
        hostName: action.value.hostName === undefined ? state.hostName : action.value.hostName,
        ipAddress: action.value.ipAddress === undefined ? state.ipAddress : action.value.ipAddress,
        macAddress: action.value.macAddress === undefined ? state.macAddress : action.value.macAddress,
      };

    case actionsType.DEVICE_SERIAL_NUMBER:
      return {...state, deviceSerialNumber: action.value};

    case actionsType.FIRMWARE_NAME:
      return {...state, firmwareName: action.value};

    case actionsType.FIRMWARE_VERSION:
      return {...state, firmwareVersion: action.value};

    case actionsType.SOFTWARE_NAME:
      return {...state, softwareName: action.value};

    case actionsType.SOFTWARE_VERSION:
      return {...state, softwareVersion: action.value};

    case actionsType.BUILD_DATE:
      return {...state, buildDate: action.value};

    case actionsType.HOST_NAME:
      return {...state, hostName: action.value};

    case actionsType.IP_ADDRESS:
      return {...state, ipAddress: action.value};

    // -------------------------------------------------
    // License
    // --------------------------------------------------
    case actionsType.UPDATE_INITIAL_LICENSE_INFO:
      // ConsoleLog(action);
      return {
        ...state,
        licenseID: action.value.Id === undefined ? state.licenseID : action.value.Id,
        licenseStatus: action.value.Result.Status === undefined ? state.licenseStatus : action.value.Result.Status,
        licenseType: action.value.Result.Type === undefined ? state.licenseType : action.value.Result.Type,
        licenseError: action.value.Result.Error === undefined ? state.licenseError : action.value.Result.Error,
        licenseURL: action.value.Result.Url === undefined ? state.licenseURL : action.value.Result.Url,
      };

    case actionsType.UPDATE_LICENSE_INFO:
      // ConsoleLog(action);
      return {
        ...state,
        clientID: action.value.ClientID === undefined ? state.clientID : action.value.ClientID,
        licenseStatus: action.value.LicenseStatus === undefined ? state.licenseStatus : action.value.LicenseStatus,
        licenseType: action.value.LicenseType === undefined ? state.licenseType : action.value.LicenseType,
        licenseModifiedDate:
          action.value.ModifiedDate === undefined ? state.licenseModifiedDate : action.value.ModifiedDate,
        licenseExpiredDate:
          action.value.ExpiredDate === undefined ? state.licenseExpiredDate : action.value.ExpiredDate,
        licenseDayLeft:
          action.value.NumberOfDaysLeft === undefined ? state.licenseDayLeft : action.value.NumberOfDaysLeft,
        trialDuration: action.value.TrialDuration === undefined ? state.trialDuration : action.value.TrialDuration,
      };

    case actionsType.CLIENT_ID:
      return {...state, clientID: action.value};

    case actionsType.LICENSE_STATUS:
      return {...state, licenseStatus: action.value};

    case actionsType.LICENSE_TYPE:
      return {...state, licenseType: action.value};

    case actionsType.LICENSE_MODIFIED_DATE:
      return {...state, licenseModifiedDate: action.value};

    case actionsType.LICENSE_EXPIRED_DATE:
      return {...state, licenseExpiredDate: action.value};

    case actionsType.LICENSE_ACTIVATION_MODE:
      return {...state, licenseActivationMode: action.value};

    case actionsType.LICENSE_TRIAL_AVAILABLE:
      return {...state, isTrialAvailable: action.value};

    case actionsType.LICENSE_DAY_LEFT:
      return {...state, licenseDayLeft: action.value};

    case actionsType.LICENSE_DAY_LEFT_CHECK_DATE:
      return {...state, licenseDayLeftCheckDate: action.value};

    case actionsType.LICENSE_DAY_LEFT_ALERT_AVAILABLE:
      return {...state, licenseDayLeftAlertAvailable: action.value};

    case actionsType.SET_DEVICE_PROPERTIES:
      return {...state, deviceProperties: action.value};

    case actionsType.SET_DEVICE_PROPERTY_NAME:
      return {
        ...state,
        deviceProperties: action.withOrigin
          ? {...state.deviceProperties, deviceName: action.value, originDeviceName: action.value}
          : {...state.deviceProperties, deviceName: action.value},
      };
    case actionsType.RESET_DEVICE_PROPERTIES:
      return {
        ...state,
        deviceProperties: initialState.deviceProperties,
      };
    case actionsType.SET_DEVICE_NAME:
      return {...state, deviceNameUserSet: action.value};

    case actionsType.SET_HARDWARE_PROPERTIES:
      return {...state, hardwareProperties: action.value};

    case actionsType.SET_AUTO_TIMEZONE:
      return {...state, autoTimezone: action.value};

    case actionsType.SET_AUTO_DATETIME:
      return {...state, autoDateTime: action.value};

    case actionsType.SET_ORIGIN_AUTO_TIMEZONE:
      return {...state, originAutoTimezone: action.value};

    case actionsType.SET_ORIGIN_AUTO_DATETIME:
      return {...state, originAutoDateTime: action.value};

    case actionsType.SET_TIMEZONE_FROM_SERVER:
      return {...state, timezoneFromServer: action.value};

    case actionsType.SET_DEVICE_DATETIME:
      return {...state, deviceProperties: {...state.deviceProperties, deviceDateTime: action.value}};

    default:
      return state;
  }
}
